
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class CsvImportWizard extends Vue {
  proceed() {
    this.$emit('proceed');
  }
}
